export default "__VITE_ASSET__Cz5PqJIV__"